import React from 'react'

const ContactPage = () =>
  <div className="page">
    Contact Us
  </div>


export default ContactPage
